/**
 * The host's current pick when the gallery runs as a picker (onboarding's
 * theme step), from studio:context's `selectedTemplateVersionId`.
 *
 * Held here, outside React, because the host posts context from the frame's
 * `load` and again on studio:ready — both can land before the gallery route
 * has mounted to listen. The gallery reads it with useSyncExternalStore.
 *
 * Its own module, not part of host-lifecycle, so suites that mock
 * host-lifecycle wholesale still get a working store.
 */
let hostSelectedTemplate: string | undefined;
const hostSelectedListeners = new Set<() => void>();

export const getHostSelectedTemplate = (): string | undefined =>
  hostSelectedTemplate;

export function subscribeHostSelectedTemplate(listener: () => void): () => void {
  hostSelectedListeners.add(listener);
  return () => {
    hostSelectedListeners.delete(listener);
  };
}

export function setHostSelectedTemplate(next: string | undefined): void {
  if (next === hostSelectedTemplate) return;
  hostSelectedTemplate = next;
  hostSelectedListeners.forEach((l) => l());
}
